
import React from "react";
import Layout from "@/components/layout/Layout";

export function OwnerPageLoadingState() {
  return (
    <Layout>
      <div className="container py-8">
        <div className="flex items-center justify-center h-64">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
        </div>
      </div>
    </Layout>
  );
}
